import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fallback", "surveyId", "surveyType", "onClose"];
import FeedbackSurveyModalContent from './FeedbackSurveyModalContent';
import useFeedbackSurveyConfig from '../hooks/useFeedbackSurveyConfig';
import { useLanguageLoader } from '../hooks/useLanguageLoader';
import { isTestModeEnabled } from '../utils/surveyUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const FeedbackSurveyModal = _ref => {
  let {
      fallback,
      surveyId,
      surveyType,
      onClose
    } = _ref,
    modalContentProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    loading: languageLoading
  } = useLanguageLoader();
  const {
    loading,
    surveyConfig,
    setSurveyConfig
  } = useFeedbackSurveyConfig({
    surveyId,
    surveyType
  });
  if (loading || languageLoading) {
    return null;
  }
  if (!(surveyConfig !== null && surveyConfig !== void 0 && surveyConfig.config)) {
    return fallback || null;
  }
  return /*#__PURE__*/_jsx(FeedbackSurveyModalContent, Object.assign({}, modalContentProps, {
    surveyConfig: surveyConfig,
    surveyId: surveyId,
    onClose: () => {
      if (isTestModeEnabled()) {
        console.log('[TEST MODE] Closing modal without unmounting component');
        onClose === null || onClose === void 0 || onClose();
      } else {
        setSurveyConfig(null);
      }
    }
  }));
};
export default FeedbackSurveyModal;